<template>
    <select @change.prevent="followLink">
        <slot />
    </select>
</template>
<script>
export default {
    methods: {
        followLink(event) {
            window.location = event.target.value
        },
    },
}
</script>
